enum TextAlign {
  CENTER = 'center',
  LEFT = 'left',
}
enum ButtonAlignment {
  DEFAULT = 'default',
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
export { TextAlign, ButtonAlignment };
